import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'generalText',
  standalone: false,
})
export class GeneralTextPipe implements PipeTransform {

  transform(values: Array<{lang_code: string, text: string}>, langCode: string): string {
    let text: string = '';
    if (!!values) {
      for (const value of values) {
        if (langCode === value.lang_code) {
          text = value.text;
          break;
        }
      }
    }
    return text;
  }

}
